import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    EnvironmentInjector,
    EnvironmentProviders,
    Provider,
    inject,
    provideEnvironmentInitializer,
    runInInjectionContext,
} from '@angular/core';
import {
    connectAuthEmulator,
    getAuth,
    provideAuth as provideFirebaseAuth,
} from '@angular/fire/auth';
import { authInterceptor } from 'app/@core/auth/auth.interceptor';
import { AuthService } from 'app/@core/auth/auth.service';
import { environment } from 'environments/environment';
import { getEmulatorHost } from '../utils/emulator-host';

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([authInterceptor])),
        provideEnvironmentInitializer(() => inject(AuthService)),
        provideFirebaseAuth(() => {
            const auth = getAuth();
            if (environment.useEmulators) {
                // getEmulatorHost() resolves asynchronously, so the .then callback
                // loses Angular's injection context — restore it explicitly.
                const injector = inject(EnvironmentInjector);
                getEmulatorHost().then(host => {
                    runInInjectionContext(injector, () => {
                        connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
                    });
                    console.log('[EMU] Auth host =', host);
                });
            }
            return auth;
        }),
    ];
};
